/* eslint-disable */
import { RouteConfig } from 'vue-router';
import { Roles } from '@/modules/authentication/models/rolesEnum';
import Results from '@/modules/results/Results.vue';
import Merger from '@/modules/results/views/Merger.vue';
import Interwinner from '@/modules/results/views/merger/Interwinner.vue';
import G2000 from '@/modules/results/views/merger/G2000.vue';

const routes: Array<RouteConfig> = [
  {
    path: '/results',
    name: 'Results',
    component: Results,
    redirect: { name: 'merger' },
    meta: { requiredRole: Roles.results_upload },
    children: [
      {
        path: '/results/merger',
        name: 'Merger',
        component: Merger,
        redirect: { name: 'Interwinner' },
        meta: {
          title: 'results.Merger.metaTitle'
        },
        children: [
          {
            path: '/results/merger/interwinner',
            name: 'Interwinner',
            component: Interwinner,
            meta: {
              title: 'results.Merger.Interwinner.metaTitle'
            }
          },
          {
            path: '/results/merger/g2000',
            name: 'G2000',
            component: G2000,
            meta: {
              title: 'results.Merger.G2000.metaTitle'
            }
          }
        ]
      }
    ]
  }
];

export default routes;
